import cx from 'classnames';
import { PageProps, StaticQuery, graphql } from 'gatsby';
import React from 'react';

import '../../styles/style.css';
import Footer from './Footer/Footer';
import Header from './Header/Header';

import CookieConesent from '@components/CookieConsent/CookieConesent';

const Page = ({
	children,
	path,
	transparent,
	transparentBorder,
	background,
	className = '',
}: {
	children: React.ReactNode;
	path?: PageProps;
	transparent?: boolean;
	transparentBorder?: boolean;
	background?: 'black' | 'white';
	className?: string;
}) => {
	return (
		<StaticQuery
			query={graphql`
				query {
					site {
						siteMetadata {
							title
						}
					}
				}
			`}
			render={(data): JSX.Element => {
				const { title } = data.site.siteMetadata;

				return (
					<>
						<div id="skiptocontent" className="visuallyhidden">
							<a href="#main">skip to main content</a>
						</div>
						<Header
							title={title}
							transparent={transparent}
							transparentBorder={transparentBorder}
						/>
						<main
							id="main"
							className={cx({
								dark: background === 'black',
								[className]: !!className,
							})}>
							{children}
							<CookieConesent />
						</main>
						<Footer />
					</>
				);
			}}
		/>
	);
};

export default Page;
